import { AgentType } from '~/containers/Conversations/ConversationsList/types';

import { axiosClient } from '../axiosClient';

export const getAgentById = (agentId: number) => {
  return axiosClient.get<AgentType>(`/agents/${agentId}`);
};
